<template>
    <div class="p-10">
        <div class="grid grid-cols-4 gap-x-8 my-4">
            <Checkbox v-for="(el,i) in NeComputedUserPreference" :key="i" :for_id="el.prop" :checked="el.visible"
                      @change="onToggle(el.prop)" checkClass="w-2 h-2">{{ el.name }}
            </Checkbox>
            <div class="col-span-4 grid grid-cols-4 gap-x-8 gap-y-2 pt-4">
                <div class="col-span-4 font-bold py-2">Acquisto</div>
                <Checkbox v-for="(el,i) in AcComputedUserPreference" :key="i" :for_id="el.prop" :checked="el.visible"
                          @change="onToggle(el.prop)" checkClass="w-2 h-2">{{ el.name }}
                </Checkbox>
            </div>
            <div class="col-span-4 grid grid-cols-4 gap-x-8 gap-y-2 pt-4">
                <div class="col-span-4 font-bold py-2">Vendita</div>
                <Checkbox v-for="(el,i) in VeComputedUserPreference" :key="i" :for_id="el.prop" :checked="el.visible"
                          @change="onToggle(el.prop)" checkClass="w-2 h-2">{{ el.name }}
                </Checkbox>
            </div>
            <div class="col-span-4 grid grid-cols-4 gap-x-8 gap-y-2 pt-4">
                <div class="col-span-4 font-bold py-2">Totali</div>
                <Checkbox v-for="(el,i) in ReComputedUserPreference" :key="i" :for_id="el.prop" :checked="el.visible"
                          @change="onToggle(el.prop)" checkClass="w-2 h-2">{{ el.name }}
                </Checkbox>
            </div>
        </div>
        <div class="flex justify-end gap-3 pt-4">
            <NextButton variant="outline-secondary"
                        @click="chiudi"
                        class="w-44 py-2 px-4">
                Chiudi
            </NextButton>
            <NextButton variant="primary"
                        @click="salva"
                        class="w-44 py-2 px-4">
                Salva
            </NextButton>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";
import {mapActions, mapGetters, mapState} from 'vuex';
import Checkbox from "@/components/Checkbox.vue";

@Options({
    name:'ViewForm',
    components: {
        NextButton,
        Checkbox,
    },
    props: {
        id: [Number, String],
    },
    computed: {
        ...mapGetters('buFieldModule', [
            'AcComputedUserPreference',
            'VeComputedUserPreference',
            'ReComputedUserPreference',
            'NeComputedUserPreference',
        ]),
    },
    methods: {
        ...mapActions('buFieldModule', [
            'toggleFieldVisibility',
        ])
    }
})
export default class ViewForm extends Vue {
    toggleFieldVisibility: any

    onToggle(prop: string) {
        this.toggleFieldVisibility(prop)
    }

    chiudi(){
        this.$emit('chiudi')
    }

    salva(){
        this.$emit('save')
        this.chiudi()
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
